import { track, CLICK } from '@updater-core/lib/tracker';

export const trackToggleDropdown = () => {
  track({
    verb: CLICK,
    object: 'mover_dropdown_toggle',
    segmentEventName: 'Clicked Mover Dropdown Toggle',
  });
};

export const trackSwitchCurrentMove = (details = {}) => {
  if (!details.moveId) {
    console.warn('trackSwitchCurrentMove requies moveId');
  }
  track({
    verb: CLICK,
    object: 'switch_move_navigation',
    segmentEventName: 'Clicked Switch Move Navigation',
    details,
  });
};

export const trackHeaderLogoNavigation = () => {
  track({
    verb: CLICK,
    object: 'header_logo_navigation',
    segmentEventName: 'Clicked Header Logo Navigation',
  });
};
